export default "__VITE_ASSET__B3R9MobZ__"